<mat-form-field class="language-picker">
  <mat-select [style.font-weight]="'bolder'" [ngClass]="darkMode ? 'light' : 'dark'" class="" [(value)]="selected" (selectionChange)="changeLanguage(selected);">
  <mat-option [style.font-weight]="'bolder'" [ngClass]="darkMode ? 'dark-mode' : 'light-mode'" *ngFor="let lan of languages" [value]="lan.value">
      {{lan.viewValue}}
    </mat-option>
  </mat-select>
</mat-form-field>
